<div class="assay-details-container" [class.print-mode]="isPrintMode">
  <div class="assay-details-body">
    <div class="assay-details-scroll bpx-report" #assayDetailsScroll>
  <!--
    The printed document is unchanged: the run-out of labels below is what has always gone to
    paper. On screen the same values read as the identification card the other tabs use.
  -->
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="Assay Details"
    [studyName]="studyName"
    [contextLine]="printContextLine"
    [tableColumns]="tableColumns"
    (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>

  <div class="bpx-detail aa-meta bpx-screen-only">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-print-only">
    <br />
    Panel Name: <span id="panel-name">{{ (panelName$ | async) }}</span><br />
    Run Type: <span id="run-type">{{ runType }}</span><br />
    Test Spec: <span id="test-spec">{{ testSpec }}</span><br />
    Assignment Spec: <span id="assignment-spec">Final</span><br />
    Operator: <span id="operator">{{ operatorName || '-' }}</span><br /><br />
  </div>
  } @else {
  <div class="bpx-detail aa-meta">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value" id="panel-name">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value" id="run-type">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value" id="test-spec">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value" id="assignment-spec">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value" id="operator">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-toolbar__actions aa-actions">
    <a class="bpx-btn" (click)="toggleAllSections(true)">Expand All Sections</a>
    <a class="bpx-btn" (click)="toggleAllSections(false)">Collapse All Sections</a>
    <span class="bpx-toolbar__sep" aria-hidden="true"></span>
    @if (showStabilityOutputs) {
    <a
      (click)="sampleDataLoading ? null : exportAsWorkbook()"
      class="bpx-btn"
      [class.bpx-btn--disabled]="sampleDataLoading || (isStudySaved$ | async) !== true"
      [attr.aria-disabled]="sampleDataLoading || (isStudySaved$ | async) !== true"
      [attr.tabindex]="sampleDataLoading || (isStudySaved$ | async) !== true ? -1 : 0"
      [style.pointer-events]="(isStudySaved$ | async) !== true ? 'none' : null">Export As Workbook</a>
    }
    @if (showStabilityOutputs) {
    <a (click)="navigateToPrintView()" class="bpx-btn"
      [class.bpx-btn--disabled]="(isStudySaved$ | async) !== true"
      [attr.aria-disabled]="(isStudySaved$ | async) !== true"
      [style.pointer-events]="((isStudySaved$ | async) !== true) ? 'none' : null">
      <mat-icon fontIcon="print"></mat-icon>Print View
    </a>
    <label class="bpx-check">
      <input
        type="checkbox"
        [checked]="printTruncatedReport"
        (change)="printTruncatedReport = $any($event.target).checked" />
      Print Truncated Report
    </label>
    }
  </div>
  }
  @if (isPrintMode) {
  @for (pageColumns of printPages; track trackByPage; let pageIndex = $index) {
  <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
    @if (printPageCaption(pageIndex)) {
    <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
    }
    <ng-container *ngTemplateOutlet="assayDetailsTableTpl; context: { $implicit: pageColumns }"></ng-container>
  </div>
  }
  } @else {
  <ng-container *ngTemplateOutlet="assayDetailsTableTpl; context: { $implicit: calResponseCombinedData }"></ng-container>
  }

  <ng-template #assayDetailsTableTpl let-pageColumns>
  <table #assayDetailsTable [attr.id]="tableId"
    class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head assay-details__table"
    [class.assay-detail-print]="isPrintMode" matTableExporter #exporter="matTableExporter">
    <thead class="bpx-report__head">
      <tr>
        <td class="!align-middle">KitLot#</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td class="!align-middle" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.lot }}
            <ng-container *ngIf="reportContentItem.valueAssigned === 'AdjustedCalculate'">
              <span class="block">{{ adjustedLabel }}</span>
            </ng-container>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Instrument ID</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
              {{ reportContentItem.reportContentItems.runId }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Assay Name</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.assay}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Bead Region</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.region}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Units</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ getUnitsByRegion(reportContentItem.reportContentItems.region)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.resultDecimalPrecision}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>User Defined Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.userDefinedDecimalPrecision}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Type</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem?.reportContentItems?.resultType }}
          </td>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      @if(isPrintMode) {
      <tr class="subsection-header-print-firstrow bpx-report__section">
        <td>
          Summary Status
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(0)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Summary Status
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[0] && shouldRenderSection(0)) {
      <tr>
        <td>Run Date</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td> {{ getPatientFileData('date') }} </td>
        </ng-container>
      </tr>
      <tr>
        <td>Instrument</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td class="adf-instrument-cell"> {{ getPatientFileData('instrumentSerialNo') }} </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Lot</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>{{ displayValue(calLots.length ? calLots[0].calLotNumber : null) }}</td>
        </ng-container>
      </tr>
      <tr>
        <td>Control Lot</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>{{ displayValue(qcLots.length ? qcLots[0].masterLotNumber : null) }}</td>
        </ng-container>
      </tr>
      <tr>
        <td>Kit Status PASS/FAIL/ALERT</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.kitStatus)">
              {{ displayValue(materialItem?.runStatus?.kitStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Specs Status</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calibratorSpecStatus)">
              {{ displayValue(materialItem?.runStatus?.calibratorSpecStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Sample Specs Status</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.patientSampleSpecStatus)">
              {{ displayValue(materialItem?.runStatus?.patientSampleSpecStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Sample Acceptance Range</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.patientSampleAcceptanceRange)">
              {{ displayValue(materialItem?.runStatus?.patientSampleAcceptanceRange) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Samples: # Run | # Specified</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            {{ displayValue(materialItem?.runStatus?.patientSamplesRun) }} | {{ displayValue(materialItem?.runStatus?.patientSamplesSpecified) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Negative Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult((runValidityPassFailAlertCount( (materialItem?.regressionStats?.negativeSamplesPASS || 0), (materialItem?.regressionStats?.negativeSamplesFAILED || 0), (materialItem?.regressionStats?.negativeSamplesALERT || 0))) )">
              {{ displayValue(runValidityPassFailAlertCount(
              (materialItem?.regressionStats?.negativeSamplesPASS || 0),
              (materialItem?.regressionStats?.negativeSamplesFAILED || 0),
              (materialItem?.regressionStats?.negativeSamplesALERT || 0))) }}
            </span>

          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Within Cut-off Range Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span
              [ngClass]="getStatusClassFromResult(runValidityPassFailAlertCount((materialItem?.regressionStats?.cutOffSamplesPASS || 0), (materialItem?.regressionStats?.cutOffSamplesFail || 0), (materialItem?.regressionStats?.CutOffSamplesAlert || 0)))">
              {{ displayValue(runValidityPassFailAlertCount((materialItem?.regressionStats?.cutOffSamplesPASS || 0),
              (materialItem?.regressionStats?.cutOffSamplesFail || 0), (materialItem?.regressionStats?.CutOffSamplesAlert
              || 0))) }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Positive Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span
              [ngClass]="getStatusClassFromResult(runValidityPassFailAlertCount((materialItem?.regressionStats?.positiveSamplesPASS || 0), (materialItem?.regressionStats?.positiveSamplesFAILED || 0), (materialItem?.regressionStats?.positiveSamplesAlert || 0)))">
              {{ displayValue(runValidityPassFailAlertCount((materialItem?.regressionStats?.positiveSamplesPASS || 0),
              (materialItem?.regressionStats?.positiveSamplesFAILED || 0),
              (materialItem?.regressionStats?.positiveSamplesAlert || 0))) }}
            </span>
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample Results - Concentration -
          <span [ngClass]="getSectionStatusClass('concentration')">{{ getSectionStatusLabel('concentration') }}</span>
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(1)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample Results - Concentration -
          <span [ngClass]="getSectionStatusClass('concentration')">{{ getSectionStatusLabel('concentration') }}</span>
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[1] && shouldRenderSection(1)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getStatusClassFromResult(getSampleData(materialItem, sample, 'resultStatus'))">
            {{ getSampleData(materialItem, sample, 'meanFinalConc') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Result (Pass/Fail/Alert)
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(2)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Result (Pass/Fail/Alert)
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[2] && shouldRenderSection(2)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getStatusClassFromResult(getSampleData(materialItem, sample, 'resultStatus'))">
            {{ getSampleData(materialItem, sample, 'resultStatus') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample Score -
          <span [ngClass]="getSectionStatusClass('score')">{{ getSectionStatusLabel('score') }}</span>
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(3)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample Score -
          <span [ngClass]="getSectionStatusClass('score')">{{ getSectionStatusLabel('score') }}</span>
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[3] && shouldRenderSection(3)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getStatusClassFromResult(getSampleData(materialItem, sample, 'resultStatus'))">
            {{ getSampleData(materialItem, sample, 'testScore') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample SD
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(4)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample SD
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[4] && shouldRenderSection(4)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'repSD') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample %CV
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(5)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample %CV
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[5] && shouldRenderSection(5)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'repCV') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample SD, %CV -
          <span [ngClass]="getSectionStatusClass('sdCv')">{{ getSectionStatusLabel('sdCv') }}</span>
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(6)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample SD, %CV -
          <span [ngClass]="getSectionStatusClass('sdCv')">{{ getSectionStatusLabel('sdCv') }}</span>
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[6] && shouldRenderSection(6)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getStatusClassFromResult(getSampleData(materialItem, sample, 'resultRepOk'))">
            {{ getSampleData(materialItem, sample, 'resultRepOk') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample RFI
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(7)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample RFI
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[7] && shouldRenderSection(7)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'meanRFI') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample FR
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(8)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample FR
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[8] && shouldRenderSection(8)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'meanFR') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Bead to Bead CV
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(9)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Bead to Bead CV
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[9] && shouldRenderSection(9)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'meanBeadCV') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Bead Count
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(10)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Bead Count
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[10] && shouldRenderSection(10)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'meanBeadCount') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Sample Time to Count
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(11)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Sample Time to Count
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[11] && shouldRenderSection(11)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'meanCountTime') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Number of Replicates
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(12)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Number of Replicates
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[12] && shouldRenderSection(12)) {
      <tr *ngFor="let sample of samplesList; trackBy: trackBySample">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'finalRepCount') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Number Replicates -
          <span [ngClass]="getSectionStatusClass('replicates')">{{ getSectionStatusLabel('replicates') }}</span>
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(13)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Number Replicates -
          <span [ngClass]="getSectionStatusClass('replicates')">{{ getSectionStatusLabel('replicates') }}</span>
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[13] && shouldRenderSection(13)) {
      <tr *ngFor="let sample of samplesList">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getStatusClassFromResult(getSampleData(materialItem, sample, 'repCountOk'))">
            {{ getSampleData(materialItem, sample, 'repCountOk') }}
          </td>
        </ng-container>
      </tr>
      }
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          Assigned Value
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay(14)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Assigned Value
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if(sectionVisibility[14] && shouldRenderSection(14)) {
      <tr *ngFor="let sample of samplesList">
        <td>{{ sample }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getSampleStatusClass(materialItem, sample)">
            {{ getSampleData(materialItem, sample, 'assignedValue') }}
          </td>
        </ng-container>
      </tr>
      }

    </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
  </table>
  </ng-template>
  @if (!isPrintMode && !calResponseCombinedData.length) {
  <p class="bpx-empty">No assay results to display.</p>
  }
    </div>
  </div>
</div>

@if (isPrintMode) {
<div class="header">
  Bio-Rad Laboratories<br />
  Redmond, WA
</div>
<div class="print-footer-cutoff" aria-hidden="true"></div>
<div class="footer">
  <div class="print-footer-left">
    {{ studyName || '-' }}<br />
    {{ (panelName$ | async) || '-' }} : Spec Rev {{ specVersion || '-' }}<br />
    Web App Version: {{ appVersion || '-' }}
  </div>
</div>
}
